import { Action, Checkbox, InputError } from '@op/opds.opux';
import React, { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/react/shallow';
import styles from './ProductDocuments.module.scss';
import { AnalyticsPhases, trackAction } from 'api/analytics-api';
import { type ProductDocument } from 'dto/productDocument';
import { useAppStore } from 'state/store';

export const ProductDocuments: FC<{
  documentsData: ProductDocument[] | null;
}> = ({ documentsData }) => {
  const { t } = useTranslation();

  const setConsentForDocuments = useAppStore(
    (state) => state.setConsentForDocuments
  );
  const { consentForDocuments, errors } = useAppStore(
    useShallow((state) => ({
      consentForDocuments: state.consentForDocuments,
      errors: state.errors,
    }))
  );

  const error = errors?.consentForDocuments;

  const documents =
    documentsData && Array.isArray(documentsData)
      ? documentsData.map((doc, index) => (
          <p key={doc.archiveRef}>
            <Action
              onClick={() => {
                trackAction(
                  doc.documentName,
                  'download',
                  AnalyticsPhases.BENEFICIARIES_AND_DOCUMENTS
                );
              }}
              external
              href={doc.documentUrl}
              data-testid={`product-document-link-${index}`}>
              {doc.documentName} ({t('productDocuments.pdf')})
            </Action>
          </p>
        ))
      : null;
  const errorId = 'product-documents-error-id';

  return (
    <div className={styles.documents}>
      <h2>{t('productDocuments.documents')}</h2>
      {documents}
      <Checkbox
        checked={consentForDocuments}
        onChange={(_, checked) => {
          setConsentForDocuments(checked);
        }}
        invalid={!!error}
        labelProps={{
          'data-testid': 'product-documents-consent-checkbox',
        }}
        id='consentForDocuments'
        aria-describedby={!!error ? errorId : undefined}
        tabIndex={0}>
        {t('productDocuments.consent')}
      </Checkbox>
      {!!error && !consentForDocuments && (
        <InputError
          error={t('productDocuments.error')}
          data-testid='product-documents-error'
          id={errorId}
        />
      )}
    </div>
  );
};
